import React from 'react';

import { Badge, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Block as BlockIcon } from '@material-ui/icons';

const useStyles = makeStyles(({ palette }) => ({
  blockedBadgeIcon: {
    backgroundColor: palette.error.main,
    color: palette.common.white,
    borderRadius: '50%',
    padding: 2,
    fontSize: 12,
  },
}));

interface BlockedContactBadgeProps {
  children: React.ReactNode;
  isBlocked: boolean;
  /** Conteúdo do badge quando o contato NÃO está bloqueado (ex: ícone do canal) */
  defaultBadgeContent?: React.ReactNode;
}

export function BlockedContactBadge({
  children,
  isBlocked,
  defaultBadgeContent,
}: BlockedContactBadgeProps) {
  const classes = useStyles();

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      badgeContent={
        isBlocked ? (
          <BlockIcon className={classes.blockedBadgeIcon} />
        ) : (
          defaultBadgeContent
        )
      }
    >
      <Box display="flex">{children}</Box>
    </Badge>
  );
}
